export const chartTypesInfo = [
  {
    id: 'violin',
    family: 'distribution',
    logo: 'Violin150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/violin.html',
    pythonURL: 'https://python-graph-gallery.com/violin-plot/',
    label: 'Violin',
  },
  {
    id: 'density',
    family: 'distribution',
    logo: 'Density150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/density.html',
    pythonURL: 'https://python-graph-gallery.com/density-plot/',
    label: 'Density',
  },
  {
    id: 'histogram',
    family: 'distribution',
    logo: 'Histogram150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/histogram.html',
    pythonURL: 'https://python-graph-gallery.com/histogram/',
    label: 'Histogram',
  },
  {
    id: 'boxplot',
    family: 'distribution',
    logo: 'Box1150',
    dataToVizURL: 'https://www.data-to-viz.com/caveat/boxplot.html',
    pythonURL: 'https://python-graph-gallery.com/boxplot/',
    label: 'Boxplot',
  },
  {
    id: 'ridgeline',
    family: 'distribution',
    logo: 'Joyplot150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/ridgeline.html',
    pythonURL: 'https://python-graph-gallery.com/ridgeline/',
    label: 'Ridgeline',
  },
  {
    id: 'beeswarm',
    family: 'distribution',
    logo: 'Beeswarm2Big',
    dataToVizURL: 'https://www.data-to-viz.com/graph',
    pythonURL: 'https://python-graph-gallery.com/beeswarm/',
    label: 'Beeswarm',
  },
  {
    id: 'scatter',
    family: 'correlation',
    logo: 'ScatterPlot150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/scatter.html',
    pythonURL: 'https://python-graph-gallery.com/scatter-plot/',
    label: 'Scatterplot',
  },
  {
    id: 'heatmap',
    family: 'correlation',
    logo: 'Heatmap150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/heatmap.html',
    pythonURL: 'https://python-graph-gallery.com/heatmap/',
    label: 'Heatmap',
  },
  {
    id: 'correlogram',
    family: 'correlation',
    logo: 'Correlogram150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/correlogram.html',
    pythonURL: 'https://python-graph-gallery.com/correlogram/',
    label: 'Correlogram',
  },
  {
    id: 'bubble',
    family: 'correlation',
    logo: 'BubblePlot150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/bubble.html',
    pythonURL: 'https://python-graph-gallery.com/bubble-plot/',
    label: 'Bubble',
  },
  {
    id: 'connectedScatter',
    family: 'correlation',
    logo: 'ScatterConnected150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/connectedscatter.html',
    pythonURL: 'https://python-graph-gallery.com/connected-scatter-plot/',
    label: 'Connected Scatter',
  },
  {
    id: 'density2d',
    family: 'correlation',
    logo: '2dDensity150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/density2d.html',
    pythonURL: 'https://python-graph-gallery.com/2d-density-plot/',
    label: '2D Density',
  },
  {
    id: 'barplot',
    family: 'ranking',
    logo: 'Bar150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/barplot.html',
    pythonURL: 'https://python-graph-gallery.com/barplot/',
    label: 'Barplot',
  },
  {
    id: 'radar',
    family: 'ranking',
    logo: 'Spider150',
    dataToVizURL: 'https://www.data-to-viz.com/caveat/spider.html',
    pythonURL: 'https://python-graph-gallery.com/radar-chart/',
    label: 'Spider / Radar',
  },
  {
    id: 'wordcloud',
    family: 'ranking',
    logo: 'Wordcloud150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/wordcloud.html',
    pythonURL: 'https://python-graph-gallery.com/wordcloud/',
    label: 'Wordcloud',
  },
  {
    id: 'parallel',
    family: 'ranking',
    logo: 'Parallel1150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/parallel.html',
    pythonURL: 'https://python-graph-gallery.com/parallel-plot/',
    label: 'Parallel',
  },
  {
    id: 'lollipop',
    family: 'ranking',
    logo: 'Lollipop150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/lollipop.html',
    pythonURL: 'https://python-graph-gallery.com/lollipop-plot/',
    label: 'Lollipop',
  },
  {
    id: 'circularBarplot',
    family: 'ranking',
    logo: 'CircularBarplot150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/circularbarplot.html',
    pythonURL: 'https://python-graph-gallery.com/circular-barplot/',
    label: 'Circular Barplot',
  },
  {
    id: 'table',
    family: 'ranking',
    logo: 'TableBig',
    dataToVizURL: 'https://www.data-to-viz.com',
    pythonURL: 'https://python-graph-gallery.com/table/',
    label: 'Table',
  },
  {
    id: 'treemap',
    family: 'partOfAWhole',
    logo: 'Tree150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/treemap.html',
    pythonURL: 'https://python-graph-gallery.com/treemap/',
    label: 'Treemap',
  },
  {
    id: 'venn',
    family: 'partOfAWhole',
    logo: 'Venn150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/venn.html',
    pythonURL: 'https://python-graph-gallery.com/venn-diagram/',
    label: 'Venn Diagram',
  },
  {
    id: 'donut',
    family: 'partOfAWhole',
    logo: 'Doughnut150',
    dataToVizURL: '',
    pythonURL: 'https://python-graph-gallery.com/donut-plot/',
    label: 'Donut',
  },
  {
    id: 'pie',
    family: 'partOfAWhole',
    logo: 'Pie150',
    dataToVizURL: 'https://www.data-to-viz.com/caveat/pie.html',
    pythonURL: 'https://python-graph-gallery.com/pie-plot/',
    label: 'Pie Chart',
  },
  {
    id: 'dendrogram',
    family: 'partOfAWhole',
    logo: 'Dendrogram150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/dendrogram.html',
    pythonURL: 'https://python-graph-gallery.com/dendrogram/',
    label: 'Dendrogram',
  },
  {
    id: 'circularPacking',
    family: 'partOfAWhole',
    logo: 'CircularPacking150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/circularpacking.html',
    pythonURL: 'https://python-graph-gallery.com/circular-packing/',
    label: 'Circular Packing',
  },
  {
    id: 'waffle',
    family: 'partOfAWhole',
    logo: 'Waffle2Small',
    dataToVizURL: 'https://www.data-to-viz.com',
    pythonURL: 'https://python-graph-gallery.com/waffle-chart/',
    label: 'Waffle',
  },
  {
    id: 'line',
    family: 'evolution',
    logo: 'Line150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/line.html',
    pythonURL: 'https://python-graph-gallery.com/line-chart/',
    label: 'Line chart',
  },
  {
    id: 'area',
    family: 'evolution',
    logo: 'Area150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/area.html',
    pythonURL: 'https://python-graph-gallery.com/area-plot/',
    label: 'Area chart',
  },
  {
    id: 'stackedArea',
    family: 'evolution',
    logo: 'StackedArea150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/stackedarea.html',
    pythonURL: 'https://python-graph-gallery.com/stacked-area-plot/',
    label: 'Stacked Area',
  },
  {
    id: 'stream',
    family: 'evolution',
    logo: 'Stream150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/streamgraph.html',
    pythonURL: 'https://python-graph-gallery.com/streamchart/',
    label: 'Streamgraph',
  },
  {
    id: 'candlestick',
    family: 'evolution',
    logo: 'CandleStick2Small',
    dataToVizURL: 'https://www.data-to-viz.com',
    pythonURL: 'https://python-graph-gallery.com/candlestick/',
    label: 'Candlestick',
  },
  {
    id: 'timeseries',
    family: 'evolution',
    logo: 'time150',
    dataToVizURL: 'https://www.data-to-viz.com',
    pythonURL: 'https://python-graph-gallery.com/timeseries/',
    label: 'Timeseries',
  },
  {
    id: 'map',
    family: 'map',
    logo: 'Map150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/map.html',
    pythonURL: 'https://python-graph-gallery.com/map/',
    label: 'Map',
  },
  {
    id: 'choropleth',
    family: 'map',
    logo: 'Choropleth150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/choropleth.html',
    pythonURL: 'https://python-graph-gallery.com/choropleth-map/',
    label: 'Choropleth',
  },
  {
    id: 'hexbin',
    family: 'map',
    logo: 'MapHexbin150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/hexbinmap.html',
    pythonURL: 'https://python-graph-gallery.com/hexbin-map/',
    label: 'Hexbin',
  },
  {
    id: 'cartogram',
    family: 'map',
    logo: 'Cartogram150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/cartogram.html',
    pythonURL: 'https://python-graph-gallery.com/cartogram/',
    label: 'Cartogram',
  },
  {
    id: 'connection',
    family: 'map',
    logo: 'ConnectedMap150',
    dataToVizURL: 'https://www.data-to-viz.com/story/MapConnection.html',
    pythonURL: 'https://python-graph-gallery.com/connection-map/',
    label: 'Connection',
  },
  {
    id: 'bubbleMap',
    family: 'map',
    logo: 'BubbleMap150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/bubblemap.html',
    pythonURL: 'https://python-graph-gallery.com/bubble-map/',
    label: 'Bubble',
  },
  {
    id: 'chordDiagram',
    family: 'flow',
    logo: 'Chord150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/chord.html',
    pythonURL: 'https://python-graph-gallery.com/chord-diagram/',
    label: 'Chord Diagram',
  },
  {
    id: 'network',
    family: 'flow',
    logo: 'Network150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/network.html',
    pythonURL: 'https://python-graph-gallery.com/network-chart/',
    label: 'Network',
  },
  {
    id: 'sankey',
    family: 'flow',
    logo: 'Sankey150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/sankey.html',
    pythonURL: 'https://python-graph-gallery.com/sankey-diagram/',
    label: 'Sankey',
  },
  {
    id: 'arc',
    family: 'flow',
    logo: 'Arc150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/arc.html',
    pythonURL: 'https://python-graph-gallery.com/arc-diagram/',
    label: 'Arc Diagram',
  },
  {
    id: 'edgeBundling',
    family: 'flow',
    logo: 'Bundle150',
    dataToVizURL: 'https://www.data-to-viz.com/graph/edge_bundling.html',
    pythonURL: 'https://python-graph-gallery.com/hierarchical-edge-bundling/',
    label: 'Edge Bundling',
  },
  {
    id: 'colors',
    family: 'general',
    logo: 'Colours150',
    dataToVizURL: '',
    pythonURL: 'https://python-graph-gallery.com/python-colors/',
    label: 'Colors',
  },
  {
    id: 'plotly',
    family: 'general',
    logo: 'Interactive150',
    dataToVizURL: '',
    pythonURL: 'https://python-graph-gallery.com/plotly/',
    label: 'Interactivity',
  },
  {
    id: 'matplotlib',
    family: 'package',
    logo: 'matplotlib',
    dataToVizURL: '',
    pythonURL: 'https://python-graph-gallery.com/matplotlib/',
    label: 'Matplotlib',
  },
  {
    id: 'seaborn',
    family: 'package',
    logo: 'seaborn',
    dataToVizURL: '',
    pythonURL: 'https://python-graph-gallery.com/seaborn/',
    label: 'Seaborn',
  },
  {
    id: 'plotnine',
    family: 'package',
    logo: 'plotnine',
    dataToVizURL: '',
    pythonURL: 'https://python-graph-gallery.com/plotnine/',
    label: 'Plotnine',
  },
  {
    id: 'pandas',
    family: 'package',
    logo: 'pandas',
    dataToVizURL: '',
    pythonURL: 'https://python-graph-gallery.com/pandas/',
    label: 'Pandas',
  },
  {
    id: 'drawarrow',
    family: 'package',
    logo: 'drawarrow',
    dataToVizURL: 'https://python-graph-gallery.com/matplotlib/#Arrow',
    pythonURL: 'https://python-graph-gallery.com/drawarrow/',
    label: 'DrawArrow',
  },
  {
    id: 'pyfonts',
    family: 'package',
    logo: 'pyfonts',
    dataToVizURL: '',
    pythonURL: 'https://python-graph-gallery.com/pyfonts/',
    label: 'PyFonts',
  },
  {
    id: 'pypalettes',
    family: 'package',
    logo: 'pypalettes',
    dataToVizURL: '/introduction-to-pypalettes',
    pythonURL: '/introduction-to-pypalettes',
    label: 'PyPalettes',
  },
  {
    id: 'animation',
    family: 'general',
    logo: 'anim150',
    dataToVizURL: '',
    pythonURL: 'https://python-graph-gallery.com/animation/',
    label: 'Animation',
  },
  {
    id: 'cheatSheets',
    family: 'general',
    logo: 'Cheat150',
    dataToVizURL: '',
    pythonURL: 'https://python-graph-gallery.com/cheat-sheets/',
    label: 'Cheat sheets',
  },
  {
    id: 'caveats',
    family: 'general',
    logo: 'Bad150',
    dataToVizURL: '',
    pythonURL: 'https://www.data-to-viz.com/caveats.html',
    label: 'Caveats',
  },
  {
    id: '3d',
    family: 'general',
    logo: '3d150',
    dataToVizURL: '',
    pythonURL: 'https://python-graph-gallery.com/3d/',
    label: '3D',
  },
  {
    id: 'statistics',
    family: 'general',
    logo: 'Stats150',
    dataToVizURL: '',
    pythonURL: 'https://python-graph-gallery.com/statistics/',
    label: 'Statistics',
  },
];
